import type { Funnelable, LocationInfo, DynamicLocationInfo } from '../types';
import { Funnel } from '../types';
import type { GeneralLocations } from './general';

export default class GeneralLocationsImpl
  implements GeneralLocations, Funnelable
{
  discovery: LocationInfo = {
    pathname: '/',
    funnels: [],
  };

  songList: LocationInfo = {
    pathname: '/browse',
    funnels: [],
  };

  demo: LocationInfo = {
    pathname: '/demo',
    funnels: [Funnel.Demo],
  };

  /** Leftover for redirect purposes. */
  oldSongDetails: DynamicLocationInfo = {
    pathname: (id: string) => `/details/${id}`,
    route: '/details/:id',
    funnels: [],
  };

  songDetails = {
    pathname: (id: string, title: string, isAIGenerated?: boolean) =>
      `/song/${isAIGenerated ? 'aisong-' : ''}${encodeURIComponent(
        title
      )}-${id}`,
    /**  Song params contains both the song name and the song id, seperated by a dash.  */
    route: '/song/:songParams',
    funnels: [],
  };

  login = {
    pathname: '/login',
    funnels: [Funnel.Subscription, Funnel.AIMusicGenerator],
  };

  logout = {
    pathname: '/logout',
    funnels: [],
  };

  register = {
    pathname: (query: string) => `/register${query}`,
    route: '/register',
    funnels: [Funnel.Subscription, Funnel.AIMusicGenerator],
  };

  passwordReset = {
    pathname: '/password/reset',
    funnels: [],
  };

  emailConfirmation = {
    pathname: (token: string) => `/confirm-email/${token}`,
    route: '/confirm-email/:emailConfirmationToken',
    funnels: [],
  };

  recommendations = {
    pathname: '/recommendations',
    funnels: [],
  };

  aiMusicGenerator = {
    pathname: '/ai-music-generator',
    funnels: [Funnel.AIMusicGenerator],
  };

  funnelsForPathname(pathname: string) {
    const {
      discovery,
      songList,
      demo,
      songDetails,
      login,
      logout,
      register,
      passwordReset,
      recommendations,
      aiMusicGenerator,
    } = this;

    if (pathname === discovery.pathname) return discovery.funnels;
    if (pathname === songList.pathname) return songList.funnels;
    if (pathname === demo.pathname) return demo.funnels;
    if (pathname === login.pathname) return login.funnels;
    if (pathname === logout.pathname) return logout.funnels;
    if (pathname === register.route) return register.funnels;
    if (pathname === passwordReset.pathname) return passwordReset.funnels;
    if (pathname === recommendations.pathname) return recommendations.funnels;
    if (pathname === aiMusicGenerator.pathname) return aiMusicGenerator.funnels;
    if (pathname.includes('/song/')) return songDetails.funnels;

    return null;
  }
}
